import React, { Component } from 'react';
import axios from '../../../axios-ns';
import { NavLink } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import * as messages from '../../../messages';
import { Link } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Aux from '../../../hoc/Aux';
import CardHeader from '@material-ui/core/CardHeader';
import Avatar from '@material-ui/core/Avatar';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import getTokenData from '../../../JwtUtils';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import SettingsIcon from '@material-ui/icons/Settings';
import CloseIcon from '@material-ui/icons/Close';
import StartIcon from '@material-ui/icons/PlayArrow';
import ChatIcon from '@material-ui/icons/Chat';
import AudioTrackIcon from '@material-ui/icons/Audiotrack';
import DoneIcon from '@material-ui/icons/Done';

class ProductWorkouts extends Component {
    state = {
        training: null,
        loading: true
    }

    componentDidMount() {
        if (localStorage.getItem('token')) {
            axios.get('protected/products/' + this.props.match.params.transactionCode + '/workouts', { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                .then(response => {
                    this.setState({ training: response.data, loading: false });
                }).catch(err => {
                    this.setState({ loading: false });
                    console.log("error");
                });
        }
    }

    chapterClickedHandler(productChapterCode) {
        this.props.history.push('/protected/workouts/' + this.props.match.params.transactionCode + "/" + productChapterCode);
    }

    handleAgreements = () => {
        axios.post('/protected/transactions/' + this.props.match.params.transactionCode + '/agreements', null, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
            .then(response => {
                this.setState({ ...this.state, training: { ...this.state.training, beforeStartAccepted: '1', beforeStartAcceptanceDate: new Date() } });
            }).catch(err => {
                console.log("error");
            })
    }

    renderSection(section, i) {
        return (<Card style={{marginBottom: '10px'}}>
            <CardHeader
                avatar={<Avatar aria-label="Recipe" style={{ backgroundColor: 'orange' }}>{i}</Avatar>}
                title={<div><span style={{ float: 'left' }}>{messages[section + '_HEAD']}</span> <span style={{ float: 'right' }}>{this.renderStars(this.state.training.report[section + 'Score'])}</span></div>}
            />
            <Card style={{ margin: '5px', padding: '5px' }}>
                <p style={{ fontSize: '10px', color: '#333' }}>
                    {messages[section + '_DESC']}
            </p>
                <p>
                    {this.state.training.report[section + 'Description']}
                </p>

                {/* <p style={{ fontSize: '10px', color: '#333' }}>
                    Jak możesz poprawić się w tym obszarze?
            </p>
                <p>
                {messages[section + '_SOL']}
            </p> */}
            </Card>
        </Card>);
}

renderStars(score) {
    let fill = +score;
    let border = 5 - +score;
    let stars = Array(fill).fill(1).map(e => <StarIcon fontSize="small" style={{ color: 'orange' }} key={Math.random()} />);
    let borderStars = Array(border).fill(1).map(e => <StarBorderIcon fontSize="small" style={{ color: 'orange' }} key={Math.random()} />);
    return (<Aux>{stars}{borderStars}</Aux>);
}


    render() {
        let chapters = null;

        if (this.state.training) {
            if (this.state.training.workouts.length === 0) {
                chapters = <p style={{ color: '#f50057' }}>{messages.PENDING_PAYMENT}</p>
            } else {
                let i = 0;
                chapters = this.state.training.workouts.map(ch => {
                    ++i;
                    let newMessage = ch.unreadMessages > 0 ? <span style={{ color: 'orange' }} title="Nowe, nieprzeczytane wiadomości"><ChatIcon fontSize="small" /> {ch.unreadMessages}</span> : <span style={{ color: '#ddd' }} title="Brak nowych wiadomości"><ChatIcon fontSize="small" /> 0 </span>;
                    let newSampleResponse = ch.unreadSampleEvaluations > 0 ? <span style={{ color: 'orange' }} title="Nowa ocena Twoich nagrań"><AudioTrackIcon fontSize="small" /> {ch.unreadSampleEvaluations}</span> : <span style={{ color: '#ddd' }} title="Brak nowych ocen nagrań"><AudioTrackIcon style={{ color: '#ddd' }} fontSize="small" /> 0 </span>;
                    let status = ch.status == 'DONE' ? <span style={{ color: 'green', marginRight: '5px' }} title="Trening ukończony"><DoneIcon fontSize="small" /></span> : null;
                    let controls = (<Aux>{status}{newMessage}{newSampleResponse}</Aux>);

                    return (
                        <Card style={{ marginBottom: '5px', cursor: 'pointer' }} key={Math.random()} onClick={() => this.chapterClickedHandler(ch.code)}>
                            <CardContent>                            
                                <Typography component="h3" variant="h3" style={{ fontSize: '15px', marginTop: '8px' }}>
                                    <Avatar style={{ float: 'left', marginRight: '15px', backgroundColor: 'orange', width: '30px', height: '30px', fontSize: '12px' }}>
                                        {i}
                                    </Avatar>
                                    Trening {i}
                                </Typography>
                                {/* <Typography variant="subtitle1" color="textSecondary" style={{ fontSize: '12px', marginTop: '8px' }}>
                                    
                                </Typography> */}
                                <span style={{ float: 'right', marginBottom: '5px' }}>{controls}</span>
                            </CardContent>
                        </Card>);
                }
                );
            }
        }

        let view = null;
        let bottomNav = null;

        if (this.state.loading) {
            view = <Spinner />
        } else if (this.state.training) {
            let message = <p></p>;
            let nowMinus2Hours = new Date();

            nowMinus2Hours.setHours(nowMinus2Hours.getHours() - 2);

            let visitDelta = (new Date() - new Date(this.state.training.lastVisitDate));

            if (new Date(this.state.training.beforeStartAcceptanceDate) > nowMinus2Hours) {
                message = <p style={{ padding: '10px' }} ><b>Wszystko gotowe!</b><br /><br /> Możemy zaczynać pracę!</p>
            } else if (this.state.training.type == 'STANDARD') {
                if (visitDelta > 86400000 * 5) {
                    message = <p style={{ padding: '10px', textAlign: 'center' }} ><ThumbDownIcon style={{ fontSize: '40px', color: 'orange' }} /><br /><br /><b>Oj, Twój zapał trochę opadł:(</b><br /><br />Ciężko będzie dokonać Ci realnych postępów bez regularnej pracy.</p>
                } else if (visitDelta > 86400000 * 3) {
                    message = <p style={{ padding: '10px', textAlign: 'center' }} ><ThumbDownIcon style={{ fontSize: '40px', color: 'orange' }} /><br /><br /><b>Trochę czasu minęło od naszego ostatniego spotkania:(</b><br /><br /> Pamiętaj aby poprawić regularność wykonywania ćwiczeń.</p>
                } else if (visitDelta < 86400000 * 3) {
                    message = <p style={{ padding: '10px', textAlign: 'center' }} ><ThumbUpIcon style={{ fontSize: '40px', color: '#252e4a' }} /><b><br /><br />Brawo! :)</b><br /><br />Regularne wykonywanie ćwiczeń to podstawa. Tak trzymaj!</p>
                }
            }

            let introduction = null;

            if (this.state.training.introduction != null) {
                introduction = <div style={{ padding: '5px', }} dangerouslySetInnerHTML={{ __html: this.state.training.introduction }}></div>;
            }

            if (this.state.training.beforeStartAccepted == '0') {
                view = <Aux>
                    <Card style={{ padding: '10px' }}>
                        <div style={{ padding: '5px', }} dangerouslySetInnerHTML={{ __html: this.state.training.beforeStart }}></div>
                        <p style={{ textAlign: 'center' }}>
                            <Button variant="contained" color="primary" style={{ display: 'inline-block', backgroundColor: 'orange', margin: '20px' }} size="small" onClick={this.handleAgreements}>
                                {messages.I_ACCEPT_COURSE_AGREEMENTS}
                            </Button>
                        </p>
                    </Card>
                </Aux>
            } else {

                let message = getTokenData('firstName') + ', przygotowałam dla Ciebie nową porcję ćwiczeń podzieloną na ' + chapters.length + ' treningi. W każdej chwili zapraszam do konsultacji - możesz do mnie przesłać swoje wykonanie ćwiczenia, lub też zadać pytanie za pomocą komunikatora. Zapraszam do regularnej pracy, a gwarantuję, że będziesz zaszokowany tym, na co stać Twój głos.';

                view = (
                    <Card style={{ marginBottom: '45px', width: '100%' }}>
                        <CardHeader
                            avatar={
                                <Avatar aria-label="Recipe" style={{ backgroundColor: this.state.training.color }}>
                                    {this.state.training.code}
                                </Avatar>
                            }
                            title={this.state.training.name}
                        />
                        <CardContent style={{ padding: '5px' }}>
                            {message}
                            {introduction}
                            <List>{chapters}</List>
                        </CardContent>
                    </Card>);

                bottomNav = (
                    <BottomNavigation style={{ width: '100%', bottom: '0', right: '0', backgroundColor: 'orange', position: 'fixed' }}>
                        <BottomNavigationAction label="Exit to menu" value="recents" icon={<CloseIcon />} component={Link} to={'/protected/dashboard'} />
                        <BottomNavigationAction label="Settings" value="recents" icon={<SettingsIcon />} component={Link} to={'/protected/training/' + this.props.match.params.transactionCode + '/options'} />
                        <BottomNavigationAction label="Start" value="recents" icon={<StartIcon />} component={Link} to={'/protected/workouts/' + this.props.match.params.transactionCode + "/" + this.state.training.workouts[0].code} />
                    </BottomNavigation>
                )
            }
        }

        if (this.state.training != null && this.state.training.evaluationStatus === 'EVALUATED') {
            let report = <Card style={{ padding: '10px', color: '#777' }}>
            <p style={{ textAlign: 'center' }}>
                <h1>Analiza Twojego wokalu</h1>
            </p>
            <p style={{textAlign: 'left', marginLeft: '30px', marginRight: '30px'}}>
            <span >Oceniający:</span> <b style={{float: 'right'}}>Karina Majewska</b><br/>
            <span >Data:</span> <b style={{float: 'right'}}>{this.state.training.report.evaluationDate}</b><br/>
            <span >Suma punktów:</span> <b style={{float: 'right'}}>{this.state.training.report.totalScore} / 35</b>
            </p>
            <p style={{borderTop: '1px solid orange', borderBottom: '1px solid orange', padding: '10px'}}>Poniżej znajdziesz szczegółową ocenę swojego nagrania w siedmu, kluczowych aspektach. Za każdy z nich możesz zdobyć maksymalnie pięć punktów. </p>
            {["a", "b", "c"].map((e, i) => this.renderSection(e, ++i))}
            <p style={{borderTop: '1px solid orange', borderBottom: '1px solid orange', padding: '10px'}}>Mam nadzieję, że powyższa analiza okaże się dla Ciebie przydatna i pozwoli Ci skoncentrować wysiłki na obszarach wymagających większej uwagi. Całą masę ćwiczeń dla wskazanych obszarów możesz znaleźć w moim Poradniku Wokalisty, dostępnym z poziomu aplikacji. Teraz możesz go nabyć 20zł taniej, wykorzystując kod zniżkowy <b>RABAT</b>.</p>
        </Card>
            return <Aux>{report}</Aux>;
        } else {
            return <Aux>
                {view}
                {bottomNav}
            </Aux>
        }

    };
}

export default ProductWorkouts;